import $ from 'jquery';
import def from './popOver.def.js';

import './tooltip.scss';

$.widget('formBuilder.popOver', def);



// WEBPACK FOOTER //
// ./src/widgets/popOver.js